import { useRouteUrl } from '@/hooks';
import { getRouteApi } from '@tanstack/react-router';

const route = getRouteApi(
    '/_org/project/$projectId/_dashboards/executive-summary',
);

export const useExecutiveSummaryUrl = () => {
    return useRouteUrl(route);
};
